var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 4.74967V4.11634C11.6667 3.22959 11.6667 2.78622 11.4941 2.44752C11.3423 2.1496 11.1001 1.90738 10.8022 1.75558C10.4635 1.58301 10.0201 1.58301 9.13333 1.58301H7.86667C6.97992 1.58301 6.53654 1.58301 6.19785 1.75558C5.89993 1.90738 5.65771 2.1496 5.50591 2.44752C5.33333 2.78622 5.33333 3.22959 5.33333 4.11634V4.74967M6.91667 9.10384V13.0622M10.0833 9.10384V13.0622M1.375 4.74967H15.625M14.0417 4.74967V13.6163C14.0417 14.9465 14.0417 15.6115 13.7828 16.1196C13.5551 16.5665 13.1918 16.9298 12.7449 17.1575C12.2369 17.4163 11.5718 17.4163 10.2417 17.4163H6.75833C5.42821 17.4163 4.76315 17.4163 4.25511 17.1575C3.80822 16.9298 3.44489 16.5665 3.21719 16.1196C2.95833 15.6115 2.95833 14.9465 2.95833 13.6163V4.74967",
    stroke: "#FF0000",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteActive);
export default __webpack_public_path__ + "static/media/delete_active.4d4ddaa9e6021d9e0329fafd0da89a55.svg";
export { ForwardRef as ReactComponent };